
   // const url = "http://localhost:4000";
   // const url = "https://tep-dashboard.herokuapp.com"
    const url = "https://services-tep.lasubeb.lg.gov.ng"

   export default url